import React, { useContext, useEffect, useState } from 'react';
import { List } from '../../../common/Widgets/List';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faSquare,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';

import { SiteContext } from '../../../../context/SiteContext';
import { ButtonContinue } from '../../../common/Button/ButtonContinue';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';
import {
  InsuranceJourneyContext,
  InsuranceJourneyState
} from '../../../common/CommonTypes';
import { Journey, PageAbsolutePath } from '../../../../consts/Common';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import useCarInsuranceController from '../../../../hooks/insuranceJourney/useCarInsuranceController';
import { useErrorBoundary } from 'react-error-boundary';

const DealersHomePage = (): JSX.Element => {
  const navigate = useNavigate();
  const { showBoundary } = useErrorBoundary();
  const { site } = useContext(SiteContext);
  const { journey, pageEvents } = useOutletContext<InsuranceJourneyContext>();

  const { dealerHomeOptions } = journey;
  const { commonEvents } = pageEvents;
  const { setQuote } = commonEvents;

  const { getNewQuote } = useCarInsuranceController();

  const [showModalPopup, setShowModalPopup] = useState(false);

  const { brand } = site;

  const { brandDisplayName, brandDisplayFullName } = brand;

  const tickComponent = <FontAwesomeIcon icon={faCheck} />;
  const squareComponent = <FontAwesomeIcon icon={faSquare} size='2xs' />;
  const chevronRightComponent = <FontAwesomeIcon icon={faChevronRight} />;

  const adminListItems: string[] = [
    'Retrieve a saved application',
    'Set a start date or edit details',
    'Generate a validation code',
    'Historical records'
  ];

  const dealerResourcesItems: string[] = [
    'Policy documents and IPID statement',
    'Marketing materials',
    'Training aids',
    'Contacts',
    'Videos'
  ];

  useEffect(() => {
    console.log(site.journeyType);
    console.log(site.journeyType === Journey.DealerJourney);
  }, []);

  const onSelectDealerResources = (): void => {
    navigate(PageAbsolutePath.Insurance.DealersResources);
  };

  const onSelectDealerAdmin = (): void => {
    navigate(PageAbsolutePath.Insurance.DealersAdminPage);
  };

  const onCustomerRegistrationSelectClick = (): void => {
    navigate(PageAbsolutePath.Insurance.CustomerSelfRegistration);
  };

  const getNewQuoteSuccess = (quote: InsuranceJourneyState) => {
    setQuote({
      ...quote,
      tiaProductCode: site.brand.tiaProductCode
    });

    navigate(PageAbsolutePath.Insurance.DriveAway);
  };

  const onBackendFailure = (err: string) => {
    showBoundary(new Error(err));
  };

  const onDealerRegistrationSelectClick = (): void => {
    getNewQuote(
      site.brand.brandName,
      site.user?.insuranceDealerCode ?? '',
      site.user.token,
      getNewQuoteSuccess,
      onBackendFailure
    );
  };

  const onFindOutMoreClick = () => {
    setShowModalPopup(true);
  };

  const getPageTitle = (): string => {
    let titleProduct = '';

    if (
      dealerHomeOptions.includeDriveaway &&
      dealerHomeOptions.includeExcessReturn
    ) {
      titleProduct = 'Driveaway, Excess return and ';
    } else if (dealerHomeOptions.includeDriveaway) {
      titleProduct = 'Driveaway and ';
    } else if (dealerHomeOptions.includeExcessReturn) {
      titleProduct = 'Excess return and ';
    }

    return `New application - ${titleProduct}Annual quote`;
  };

  const pageTitle = getPageTitle();

  return (
    <div className='table-flex-layout dealer-home'>
      <div className='form-container'>
        <div className='flex-row'>
          <h3>{pageTitle}</h3>
        </div>
        <div className='flex-row'>
          <div className='two-columns'>
            <List
              id='brand-options'
              listItems={dealerHomeOptions.brandOptions}
              title={`${brandDisplayName} vehicles only:`}
              icon={tickComponent}
            />
          </div>
          <div className='two-columns'>
            <List
              id='non-brand-options'
              listItems={dealerHomeOptions.nonBrandOptions}
              title={`Non-${brandDisplayName} vehicles:`}
              icon={tickComponent}
            />
          </div>
        </div>
        {(dealerHomeOptions.showDealerRegistration ||
          dealerHomeOptions.showCustomerSelfRegistration) && (
          <div className='flex-row'>
            <div style={{ width: '100%' }}>
              <p>Please select an option for completing the application:</p>
              <ul>
                {dealerHomeOptions.showDealerRegistration && (
                  <li className='flex-row list-widget-item '>
                    <div className='list-widget-icon m1-right'>
                      <i>{squareComponent}</i>
                    </div>
                    <div>Dealer Registration (Dealer registers customer)</div>

                    <ButtonContinue
                      text='Select'
                      name='select'
                      additionalClassNames='btn-ok margin-left-auto'
                      onClick={onDealerRegistrationSelectClick}
                    />
                  </li>
                )}
                {dealerHomeOptions.showCustomerSelfRegistration && (
                  <li className='flex-row list-widget-item '>
                    <div className='list-widget-icon m1-right'>
                      <i>{squareComponent}</i>
                    </div>
                    <div>Customer Self-Registration (Valid email address)</div>

                    <ButtonContinue
                      text='Select'
                      name='select'
                      additionalClassNames='btn-ok margin-left-auto'
                      onClick={onCustomerRegistrationSelectClick}
                    />
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}
        <div className='links-widget'>
          <ul>
            <li className='flex-row links-widget-item'>
              <div className='links-widget-icon'>{chevronRightComponent}</div>
              <Link onClick={onFindOutMoreClick} to={''}>
                {'Find out more'}
              </Link>
            </li>
          </ul>
        </div>
        <div className='flex-row dealer-admin-menu'>
          <div className='flex-row'>
            <h4>Dealer Admin</h4>
            <ButtonContinue
              text='Select'
              name='select'
              additionalClassNames='btn-ok margin-left-auto'
              onClick={onSelectDealerAdmin}
            />
          </div>
          <ul className='list-widget'>
            {adminListItems.map((item, i) => (
              <li key={`admin-list-item-${i}`}>
                {tickComponent}
                <span className='item-text'>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className='flex-row dealer-resources-menu'>
          <div className='flex-row'>
            <h4>Dealer Resources</h4>
            <ButtonContinue
              text='Select'
              name='dealer-resources-select'
              additionalClassNames='btn-ok margin-left-auto'
              onClick={onSelectDealerResources}
            />
          </div>
          <ul className='list-widget'>
            {dealerResourcesItems.map((item, i) => (
              <li key={`admin-list-item-${i}`}>
                {tickComponent}
                <span className='item-text'>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Modal
        role='modal-popup'
        isOpen={showModalPopup}
        className={`insurance-${site.brand.brandName} modal-wide-component`}
        toggle={() => {
          setShowModalPopup(false);
        }}>
        <ModalHeader
          toggle={() => {
            setShowModalPopup(false);
          }}></ModalHeader>
        <ModalBody>
          <p className='m1-bottom'>
            We provide Dealers with a digital method of generating Excess Return
            and applying for Free Driveaway Insurance. This process supports the
            Dealer's 'Duty of Care' rules that ensure customers vehicles will
            always be insured upon delivery at their homes or collection from
            the dealership.
          </p>
          <p className='m1-bottom'>
            You may be wondering what the difference is between the traditional
            method of registering customers and the new Digital & Contactless
            process?
          </p>
          <h5 className='m1-bottom'>Data Entry</h5>
          <ul className='m1-bottom'>
            <li>
              The customer completes the registration process for Excess Return
              and applies for Free Driveaway insurance themself
            </li>
            <li>
              The Dealer only enters VRN (new cars only) and the start date/time
              to activate Driveaway cover. All other details are entered by the
              customer
            </li>
          </ul>
          <h5 className='m1-bottom'>Paperless Process</h5>
          <ul className='m1-bottom'>
            <li>
              No requirement to provide the customer with hard copies of Excess
              Return voucher or insurance documents at vehicle handover as
              customer is provided via email direct from {brandDisplayFullName}{' '}
              Insurance
            </li>
            <li>
              As there is no exchange of hard copy insurance documents and,
              because the customer enters their own details, there is no need to
              get the customer to sign the 'Statement of Facts' at vehicle
              handover
            </li>
          </ul>
          <h5 className='m1-bottom'>The Process</h5>
          <ul className='m1-bottom'>
            <li>
              Dealer logs onto {brandDisplayFullName} Insurance Portal and
              selects Customer Self-Registration (Valid email address required)
            </li>
            <li>Dealer enters customer's email address and select 'Send'</li>
            <li>
              Having received the email link, the customer completes the
              registration process which when saved will appear in Dealer Admin
            </li>
            <li>
              At or before Handover, Dealer logs onto {brandDisplayFullName}{' '}
              Insurance Portal, selects customer's application and activates it
              by entering the VRN & Start date/time.
            </li>
            <li>
              Customers receives Excess Return voucher and insurance document
              set direct from {brandDisplayFullName} Insurance
            </li>
          </ul>
        </ModalBody>
        <ModalFooter>
          <ButtonContinue
            name='btn-cancel'
            text='Close'
            additionalClassNames='btn-cancel'
            onClick={() => {
              setShowModalPopup(false);
            }}
          />
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DealersHomePage;
